import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router";
import { api } from "../lib/api.js";
import { categoryLabel, data, restrictionLevel, type RestrictionEntry, type StockRow, type YutaiIndexEntry } from "../lib/data.js";
import { AuthGate } from "../components/AuthGate.js";
import { ErrorText } from "../components/ui.js";

export function FavoritesPage() {
  return (
    <AuthGate>
      <FavoritesInner />
    </AuthGate>
  );
}

function FavoritesInner() {
  const [codes, setCodes] = useState<string[]>([]);
  const [stocks, setStocks] = useState<Map<string, StockRow>>(new Map());
  const [yutai, setYutai] = useState<Map<string, YutaiIndexEntry>>(new Map());
  const [restrictions, setRestrictions] = useState<Record<string, RestrictionEntry[]>>({});
  const [sort, setSort] = useState<"code" | "month">("code");
  const [error, setError] = useState<unknown>(null);

  const reload = () => api.favorites().then((r) => setCodes(r.favorites.map((f) => f.stockCode))).catch(setError);
  useEffect(() => {
    void reload();
    data.stocks().then((s) => setStocks(new Map(s.map((x) => [x.code, x]))));
    data.yutaiIndex().then((y) => setYutai(new Map(y.map((x) => [x.code, x]))));
    data.restrictions().then(setRestrictions);
  }, []);

  const sorted = useMemo(() => {
    const list = [...codes];
    if (sort === "month") {
      list.sort((a, b) => (yutai.get(a)?.recordMonths[0] ?? 99) - (yutai.get(b)?.recordMonths[0] ?? 99) || a.localeCompare(b));
    } else list.sort();
    return list;
  }, [codes, sort, yutai]);

  return (
    <section>
      <div className="row between">
        <h1>お気に入り</h1>
        <select className="input" value={sort} onChange={(e) => setSort(e.target.value as typeof sort)}>
          <option value="code">コード順</option>
          <option value="month">権利確定月順</option>
        </select>
      </div>
      <ErrorText error={error} />
      <ul className="list">
        {sorted.map((code) => {
          const y = yutai.get(code);
          const lvl = restrictionLevel(restrictions[code]);
          return (
            <li key={code} className="row between">
              <Link to={`/stocks/${code}`}>
                <strong>{code}</strong> {stocks.get(code)?.name ?? ""}
                {y && <span className="muted"> / {y.recordMonths.join("・")}月 / {y.categoryTags.map((t) => categoryLabel[t] ?? t).join("・")}</span>}
                {lvl && <span className={`badge ${lvl}`}> {lvl === "stop" ? "停止" : "注意"}</span>}
              </Link>
              <button
                className="btn small"
                type="button"
                onClick={async () => {
                  await api.removeFavorite(code);
                  await reload();
                }}
              >
                解除
              </button>
            </li>
          );
        })}
      </ul>
      {codes.length === 0 && <p className="muted">銘柄詳細の「☆ お気に入り」から追加できます。</p>}
    </section>
  );
}
